export default __webpack_public_path__ + "static/media/ssl.eddcb8f6.png";